import { WEB_SOCKET_PORT } from "../../env/url";

import Stomp from 'stompjs';
import { Auth } from "../../util/auth";
import { showNotification } from "./push-notification";
import { openLogoutConfirmModal, getNotification, setNotificationCount } from "./header";
import { NotificationDto } from "./entity/NotificationDto";
import miniLogo from "../../assets/images/mini-logo.png";
import notificationSoundMp3 from "../../assets/sounds/notification-sound.mp3";
import { getURL } from "../../util/util";


export var stompClient;
var notificationSound;
var user;
var count;
var notification;
// var SockJs;


export function getWebSocket() {
    user = Auth.getUser();
    notificationSound = new Audio();
    notificationSound.src = notificationSoundMp3;
    stompClient = createWebSocket();
    subscribeToWebSocketForNotifications();
}

function createWebSocket() {
    // let params: HttpParams = new HttpParams();
    var headers = {
        'tenant-id': user.tenantId,
        'Origin': 'https://nba.dhi-edu.com',
        'Referer': 'https://nba.dhi-edu.com/'
    };
    const socket = new SockJS(WEB_SOCKET_PORT, headers);
    stompClient = Stomp.over(socket);
    return stompClient;
}


export function getHeaders() {
    var headers = new Headers();
    headers = {
        'Content-Type': 'application/json;',
        Authorization: 'Bearer ' + sessionStorage.getItem("token"),
        'tenant-id': Auth.getUser().tenantId,
        'academic-type': Auth.getUser().academicLevel,
        Accept: '*/*'
    };
    return headers;
}

function subscribeToWebSocketForNotifications() {
    var socketNotification;
    stompClient.connect({}, function () {
        stompClient.subscribe('/notifications', function (response) {
            var resp = JSON.parse(response.body);
            socketNotification = new NotificationDto(resp.id, resp.userId, resp.notificationMessage,
                resp.notificationTitle, resp.viewed, resp.notified, resp.webRoutingLink,
                resp.mobileRoutingLink, resp.category, resp.type, resp.logoutRequired)
            if (socketNotification.userId === Auth.getUser().id) {
                setNotification(socketNotification, true);
                if (socketNotification.logoutRequired) {
                    openLogoutConfirmModal();
                }
            }
        });
    });
}

export function setNotification(notify, isWebscoket) {
    if (notify != null) {
        notification = {
            'title': notify.notificationTitle,
            'body': notify.notificationMessage,
            'icon': miniLogo
        };
        if (notification != null) {
            // getNotification();
            showNotification(notification.title, notification.body,
                miniLogo, 10000);
            // notificationSound.load();
            // notificationSound.play();
        }
        // if (!isWebscoket) {

        //     notify.notified = true;
        //     updateSetNotification(notify);
        // } else {
        //     setNotificationCount();
        // }
    }
    return null;
}

function updateSetNotification(notification) {
    fetch(getURL(Auth.getAcademicLevel()).url + '/notifications/' +
        notification.id, {
        method: 'PUT',
        mode: 'cors',
        cache: 'no-cache',
        credentials: 'same-origin',
        headers: getHeaders(),
        redirect: 'follow',
        referrerPolicy: 'no-referrer',
        body: JSON.stringify(notification)
    });
}
